var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPayout = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0-1.903a2.097 2.097 0 1 1 0-4.194 2.097 2.097 0 0 1 0 4.194",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M18 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M21 5a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zM4 7h16a2 2 0 0 0 2 2v6a2 2 0 0 0-2 2H4a2 2 0 0 0-2-2V9a2 2 0 0 0 2-2",
  clipRule: "evenodd"
})));
export { SvgPayout as ReactComponent };
export default __webpack_public_path__ + "assets/images/payout.svg";